// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ReactUtils$SmartcutsMacros = require("../../bs-utils/src/ReactUtils.bs.js");

function t_encode(v) {
  switch (v) {
    case /* WhileRecording */0 :
        return ["WhileRecording"];
    case /* BeforePlayback */1 :
        return ["BeforePlayback"];
    case /* BeforeMultiUrlTriggeringPlayback */2 :
        return ["BeforeMultiUrlTriggeringPlayback"];
    case /* BeforeBatchSheetPlayback */3 :
        return ["BeforeBatchSheetPlayback"];
    case /* BeforeCreateSheetOnInstallSmartcut */4 :
        return ["BeforeCreateSheetOnInstallSmartcut"];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BeforeBatchSheetPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BeforeBatchSheetPlayback */3
                  };
          }
      case "BeforeCreateSheetOnInstallSmartcut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BeforeCreateSheetOnInstallSmartcut */4
                  };
          }
      case "BeforeMultiUrlTriggeringPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BeforeMultiUrlTriggeringPlayback */2
                  };
          }
      case "BeforePlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BeforePlayback */1
                  };
          }
      case "WhileRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WhileRecording */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(context) {
  switch (context) {
    case /* WhileRecording */0 :
        return "WhileRecording";
    case /* BeforePlayback */1 :
        return "BeforePlayback";
    case /* BeforeMultiUrlTriggeringPlayback */2 :
        return "BeforeMultiUrlTriggeringPlayback";
    case /* BeforeBatchSheetPlayback */3 :
        return "BeforeBatchSheetPlayback";
    case /* BeforeCreateSheetOnInstallSmartcut */4 :
        return "BeforeCreateSheetOnInstallSmartcut";
    
  }
}

function fromPlaybackTrigger(playbackTrigger) {
  if (playbackTrigger !== 4) {
    if (playbackTrigger >= 2) {
      return /* BeforePlayback */1;
    } else {
      return /* BeforeMultiUrlTriggeringPlayback */2;
    }
  } else {
    return /* BeforeBatchSheetPlayback */3;
  }
}

var Context = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromPlaybackTrigger: fromPlaybackTrigger
};

var closeModal = CssJs.style([
      CssJs.important(CssJs.$$float("right")),
      CssJs.important(CssJs.cursor("pointer"))
    ]);

var contentModal = CssJs.style([
      CssJs.important(CssJs.width(CssJs.vw(60))),
      CssJs.important(CssJs.maxHeight(CssJs.vh(80))),
      CssJs.important(CssJs.overflowY("auto"))
    ]);

var actionsSection = CssJs.style([
      CssJs.important(CssJs.marginTop(CssJs.px(20))),
      CssJs.important(CssJs.marginBottom(CssJs.px(20)))
    ]);

var explanation = CssJs.style([CssJs.important(CssJs.textAlign("left"))]);

var Style = {
  closeModal: closeModal,
  contentModal: contentModal,
  actionsSection: actionsSection,
  explanation: explanation
};

function Modal__WebAuth(Props) {
  var onClickConnectWithMyGoogleAccount = Props.onClickConnectWithMyGoogleAccount;
  var context = Props.context;
  var onClose = Props.onClose;
  var match = React.useState(function () {
        return false;
      });
  var setIsClicked = match[1];
  React.useEffect((function () {
          ((WebFont.load({google: {families: ['Roboto:wght@500']}})));
          
        }), []);
  var tmp;
  var exit = 0;
  switch (context) {
    case /* WhileRecording */0 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension requires OAuth access to your\n           Google Account's Google Sheets in order to determine what changes\n           you're making to your sheet while you're recording yourself making\n           changes to it.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension reuses OAuth access to your\n           Google Account later in order to access to your Google Sheets\n           to replay any edits you want made in the sheet.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension also requires OAuth access to your\n           Google Account when using the Smartcuts Google Sheets batch replay\n           features. Using access to your account, the extension creates a sheet\n           that you can fill in with values that are used by your smartcut to fill\n           in forms when replaying your actions. Every row will cause a different\n           replay of your smartcut, using the values from that row. The extension\n           also therefore also requires access to read the spreadsheet values, so\n           it can use them during replays.")));
        break;
    case /* BeforePlayback */1 :
    case /* BeforeMultiUrlTriggeringPlayback */2 :
        exit = 1;
        break;
    case /* BeforeBatchSheetPlayback */3 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension requires OAuth access to your Google\n           Account's Google Sheets in order to create a sheet that you can\n           fill in. The values you fill in are used by your smartcut to customize\n           what to fill in to forms when  replaying your actions. Every row will\n           cause a different replay of your smartcut, using the values from that\n           row. The extension also therefore also requires access to read the\n           spreadsheet values, so it can use them during replays.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension reuses OAuth access to your\n           Google Account later in order to support your ability to record\n           and replay smartcuts that edit a Google Sheet. The extension uses\n           the API to determine what changes you're making to your sheet\n           while you're recording yourself making those edits. When you replay\n           this smartcut, the extension uses its access to your Google Sheets\n           to replay any edits you want made in the sheet.")));
        break;
    case /* BeforeCreateSheetOnInstallSmartcut */4 :
        tmp = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension requires OAuth access to your\n                  Google Account's Google Sheets in order to create a sheet involved\n                  in this smartcut and to edit the sheet, according to the steps in\n                  this smartcut automation.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension reuses OAuth access to your\n                    Google Account later in order to support your ability to record\n                    smartcuts that edit a Google Sheet. The extension uses\n                    the API to determine what changes you're making to your sheet\n                    while you're recording yourself making those edits.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("And finally, the Smartcuts Chrome extension also requires\n                    OAuth access to your Google Account when using the Smartcuts Google\n                    Sheets batch replay features. Using access to your account, the\n                    extension creates a sheet that you can fill in with values that are\n                    used by your smartcut to fill in forms when replaying your actions.\n                    Every row will cause a different replay of your smartcut, using the\n                    values from that row. The extension also therefore also requires\n                    access to read the spreadsheet values, so it can use them during\n                    replays.")));
        break;
    
  }
  if (exit === 1) {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension requires OAuth access to your\n                    Google Account's Google Sheets in order for the automation\n                    to make any edits you want made in the sheet.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension reuses OAuth access to your\n                    Google Account later in order to support your ability to record\n                    smartcuts that edit a Google Sheet. The extension uses\n                    the API to determine what changes you're making to your sheet\n                    while you're recording yourself making those edits.")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("And finally, the Smartcuts Chrome extension also requires\n                    OAuth access to your Google Account when using the Smartcuts Google\n                    Sheets batch replay features. Using access to your account, the\n                    extension creates a sheet that you can fill in with values that are\n                    used by your smartcut to fill in forms when replaying your actions.\n                    Every row will cause a different replay of your smartcut, using the\n                    values from that row. The extension also therefore also requires\n                    access to read the spreadsheet values, so it can use them during\n                    replays.")));
  }
  return React.createElement("div", {
              className: "overlay flexbox"
            }, React.createElement("section", {
                  className: "card center flexbox " + contentModal
                }, React.createElement("a", {
                      className: closeModal,
                      onClick: (function (param) {
                          return Curry._1(onClose, undefined);
                        })
                    }, ReactUtils$SmartcutsMacros.s("close")), React.createElement("h3", undefined, ReactUtils$SmartcutsMacros.s("Connect your Google Account to Smartcuts")), React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.display("flex"),
                            tl: {
                              hd: Css.alignItems("center"),
                              tl: /* [] */0
                            }
                          })
                    }, React.createElement("img", {
                          className: Curry._1(Css.style, {
                                hd: Css.borderRadius(Css.px(2)),
                                tl: {
                                  hd: Css.marginLeft(Css.px(1)),
                                  tl: /* [] */0
                                }
                              }),
                          src: browser.runtime.getURL("/img/google_logo_oauth_2x.png")
                        }), React.createElement("span", {
                          className: Curry._1(Css.style, {
                                hd: Css.marginLeft(Css.px(1)),
                                tl: {
                                  hd: Css.marginRight(Css.px(20)),
                                  tl: {
                                    hd: Css.fontSize(Css.px(16)),
                                    tl: /* [] */0
                                  }
                                }
                              })
                        }, ReactUtils$SmartcutsMacros.s("&")), React.createElement("img", {
                          className: Curry._1(Css.style, {
                                hd: Css.width(Css.px(46)),
                                tl: {
                                  hd: Css.height(Css.px(46)),
                                  tl: /* [] */0
                                }
                              }),
                          src: browser.runtime.getURL("/icons/icon128.png")
                        })), React.createElement("section", {
                      className: "actions " + actionsSection
                    }, match[0] ? React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Waiting ...")) : React.createElement("button", {
                            className: "action$initWebAuth " + Curry._1(Css.style, {
                                  hd: Css.important(Css.cursor("pointer")),
                                  tl: {
                                    hd: Css.important(Css.height(Css.px(42))),
                                    tl: {
                                      hd: Css.important(Css.width(Css.px(198))),
                                      tl: {
                                        hd: Css.important(Css.padding("zero")),
                                        tl: {
                                          hd: Css.important(Css.backgroundColor(Css.hex("4285F4"))),
                                          tl: {
                                            hd: Css.important(Css.textAlign("left")),
                                            tl: {
                                              hd: Css.selector("& > *", {
                                                    hd: Css.important(Css.verticalAlign("middle")),
                                                    tl: /* [] */0
                                                  }),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }),
                            onClick: onClickConnectWithMyGoogleAccount !== undefined ? (function (evt) {
                                  Curry._1(setIsClicked, (function (param) {
                                          return true;
                                        }));
                                  return Curry._1(onClickConnectWithMyGoogleAccount, evt);
                                }) : (function (param) {
                                  return Curry._1(setIsClicked, (function (param) {
                                                return true;
                                              }));
                                })
                          }, React.createElement("img", {
                                className: Curry._1(Css.style, {
                                      hd: Css.borderRadius(Css.px(2)),
                                      tl: {
                                        hd: Css.marginLeft(Css.px(1)),
                                        tl: /* [] */0
                                      }
                                    }),
                                src: browser.runtime.getURL("/img/google_logo_oauth_1x.png")
                              }), React.createElement("span", {
                                className: Curry._1(Css.style, {
                                      hd: Css.important(Css.fontFamily({
                                                NAME: "custom",
                                                VAL: "'Roboto', sans-serif"
                                              })),
                                      tl: {
                                        hd: Css.important(Css.marginLeft(Css.px(11))),
                                        tl: {
                                          hd: Css.important(Css.fontSize(Css.px(14))),
                                          tl: {
                                            hd: Css.important(Css.display("inlineBlock")),
                                            tl: {
                                              hd: Css.important(Css.fontWeight({
                                                        NAME: "num",
                                                        VAL: 500
                                                      })),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    })
                              }, ReactUtils$SmartcutsMacros.s("Continue with Google")))), React.createElement("section", {
                      className: explanation
                    }, tmp, React.createElement("h4", {
                          className: Curry._1(Css.style, {
                                hd: Css.marginTop(Css.px(30)),
                                tl: /* [] */0
                              })
                        }, ReactUtils$SmartcutsMacros.s("Explanation of our collection of certain Google Sheets data")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("The Smartcuts Chrome extension collects the values of the Google Sheet\n           cells that you interact with while you record your smartcut and sends it\n           to Smartcuts' servers in order to create your smartcut. The extension\n           also collects and sends to Smartcuts' servers and the 3rd party issue\n           tracking service, "), React.createElement("a", {
                              href: "https://sentry.io",
                              target: "_blank"
                            }, ReactUtils$SmartcutsMacros.s("Sentry")), ReactUtils$SmartcutsMacros.s(", the values of the individual cells involved in replays that have failed\n           in order to help our team diagnose why a replay may have failed. In no\n           other instance do we send your Google Sheet data to our servers or to any\n           other 3rd party servers, except to Google's servers when we access the\n           Google APIs. For more information, please refer to our "), React.createElement("a", {
                              href: "/privacy_policy.html",
                              target: "_blank"
                            }, ReactUtils$SmartcutsMacros.s("privacy policy")), ReactUtils$SmartcutsMacros.s(".")))));
}

var make = Modal__WebAuth;

exports.Context = Context;
exports.Style = Style;
exports.make = make;
/* closeModal Not a pure module */
